import { Row, Totals } from './YoutubeReportClipboardTable';
import { creatorbase, influencer, youtube } from '@round/api';
import { getYoutubeTotalEngagement } from 'Modules/Plans/Posts/helpers';
import { CampaignTableRow } from 'Modules/Plans/Project/ProjectDetails/components/ProjectCampaignsTable/ProjectCampaignsTable';
import { isNumber } from 'utility/utility';

const getPostStats = (post: creatorbase.YoutubePost | creatorbase.PublicYoutubePost) => {
    const totalEngagement = getYoutubeTotalEngagement(post);
    const engagementRate = totalEngagement && post.view_count ? totalEngagement / post.view_count : null;
    return {
        views: post.view_count,
        cost: post.cost,
        likes: post?.youtube_details?.like_count,
        comments: post?.youtube_details?.comment_count,
        engagementRate: engagementRate,
    };
};

type MapToClipboardReportRowParams = {
    post: creatorbase.YoutubePost | creatorbase.PublicYoutubePost;
    channel?: youtube.Channel | null;
};

export const mapToClipboardReportRow = ({ post, channel }: MapToClipboardReportRowParams): Row => {
    const itemStats = getPostStats(post);

    return {
        status: post.status,
        channel: channel?.title,
        link: post.post_url,
        uploadDate: post.upload_date,
        ...itemStats,
    };
};

export const mapToClipboardTableTotals = (
    stats: creatorbase.AggregatedPostStats | influencer.AggregatedPostStats | null,
    rows: Row[],
    campaign?: creatorbase.Campaign | CampaignTableRow
): Totals => {
    const comments = rows.reduce((acc, row) => acc + (row.comments ?? 0), 0);
    const likes = rows.reduce((acc, row) => acc + (row.likes ?? 0), 0);
    const cost = rows.reduce((acc, row) => acc + (row.cost ?? 0), 0);

    return {
        comments,
        likes,
        engagementRate: stats?.engagement_rate,
        views: stats?.view_count,
        // public report campaigns don't have these fields and don't need to be provided
        // so always fallback to aggregated cost
        cost: !campaign?.is_post_cost_editable && isNumber(campaign?.cost) ? campaign?.cost : cost,
    };
};
